export default __webpack_public_path__ + "static/reel-sprites-cf18b8b2ef019a9571c06ee99b9af131.jpg";